import { render } from "./SubmissionPrint.vue?vue&type=template&id=0dd39bd0&scoped=true&ts=true"
import script from "./SubmissionPrint.vue?vue&type=script&lang=ts"
export * from "./SubmissionPrint.vue?vue&type=script&lang=ts"

import "./SubmissionPrint.vue?vue&type=style&index=0&id=0dd39bd0&scoped=true&lang=css"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd39bd0"]])

export default __exports__